// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_22mx0","content-wrapper":"_1Vq_K","image-wrapper":"_2RcqE","image":"_2cR4L","content":"bo34m","error-code-msg":"_29bYl","main-title":"_1SrMW","go-back-btn":"sH8es"};